__turbopack_context__.v({
  "accordionButton": "_9u04aq_accordionButton",
  "accordionContent": "_9u04aq_accordionContent",
  "accordionItem": "_9u04aq_accordionItem",
  "accordionItemWrapper": "_9u04aq_accordionItemWrapper",
  "accordionList": "_9u04aq_accordionList",
  "accordionSection": "_9u04aq_accordionSection",
  "accordionSubtitle": "_9u04aq_accordionSubtitle",
  "accordionTitle": "_9u04aq_accordionTitle",
  "contentWrapper": "_9u04aq_contentWrapper",
  "headingWrapper": "_9u04aq_headingWrapper",
  "imageSection": "_9u04aq_imageSection",
  "plusIcon": "_9u04aq_plusIcon",
  "section": "_9u04aq_section",
  "swapContainer": "_9u04aq_swapContainer",
  "swapImage": "_9u04aq_swapImage",
  "swapLayer": "_9u04aq_swapLayer",
});
